export default "__VITE_ASSET__B40TehZ9__"